module.exports = __webpack_public_path__ + "static/media/l_itdot_10.52e543e3.png";